(function () {
  /**
   * Searchable area picker — mirrors mobile_app's iraq_area_picker_sheet.dart:
   * a sheet scoped to ONE already-chosen governorate, search box filtering
   * only that governorate's areas (not nationwide), substring + Arabic-
   * normalized match against the current-locale label, sorted alphabetically.
   */

  var STR = (window.ErosAccountStrings && window.ErosAccountStrings.addresses) || {};
  function t(key, fallback) {
    return STR[key] || fallback;
  }

  /**
   * @param {object} governorate catalog governorate object (with .areas)
   * @param {string} languageCode 'ar'|'en'|'ku'
   * @param {string|null} selectedAreaId
   * @param {function(area)} onPick
   */
  function open(governorate, languageCode, selectedAreaId, onPick) {
    var sorted = governorate.areas
      .slice()
      .sort(function (a, b) {
        return window.ErosIraqAddressCatalog.areaLabelForLocale(a, languageCode).localeCompare(
          window.ErosIraqAddressCatalog.areaLabelForLocale(b, languageCode),
          languageCode
        );
      });

    var body = window.ErosUI.el('div', 'eros-area-picker');

    var searchInput = window.ErosUI.el('input', 'input eros-area-picker__search', {
      type: 'search',
      placeholder: t('area_search_placeholder', 'ابحث عن منطقتك...'),
    });
    body.appendChild(searchInput);

    var listEl = window.ErosUI.el('div', 'eros-area-picker__list');
    body.appendChild(listEl);

    function renderList(query) {
      listEl.innerHTML = '';
      var filtered = sorted.filter(function (area) {
        return window.ErosIraqAddressCatalog.searchContains(window.ErosIraqAddressCatalog.areaLabelForLocale(area, languageCode), query);
      });

      if (!filtered.length) {
        var empty = window.ErosUI.el('p', 'text-subdued');
        empty.textContent = t('area_no_results', 'لا توجد نتائج');
        listEl.appendChild(empty);
        return;
      }

      filtered.forEach(function (area) {
        var item = window.ErosUI.el('button', 'eros-area-picker__item', { type: 'button' });
        if (String(area.id) === String(selectedAreaId)) item.classList.add('eros-area-picker__item--selected');
        item.textContent = window.ErosIraqAddressCatalog.areaLabelForLocale(area, languageCode);
        item.addEventListener('click', function () {
          sheet.close();
          onPick(area);
        });
        listEl.appendChild(item);
      });
    }

    renderList('');
    searchInput.addEventListener('input', function () {
      renderList(searchInput.value);
    });

    var sheet = window.ErosUI.openSheet({
      title: window.ErosIraqAddressCatalog.governorateNameForLocale(governorate, languageCode),
      content: body,
    });

    searchInput.focus();
  }

  window.ErosIraqAreaPicker = { open: open };
})();
